const { fetchProduct } = require('../helpers/productHelper');

module.exports = {
  attach: function() {
    $('body').on('click', '.product', function(e) {
      var clickedProductId = $(this).data('pid').toString();
      var products = $('#gtm-pdp-products').attr('data-gtm-products');
      var productClicked = JSON.parse(products).filter(p => p.id === clickedProductId || p.variantId === clickedProductId);
      
      if (productClicked.length === 0 ) {
        fetchProduct(clickedProductId).then( ( { response, list }) => {
            productClicked = {
              list,
              ...response,
            };
            
            $('body').trigger('gtm:eec:productClicks', productClicked);
        });
      } else {
        $('body').trigger('gtm:eec:productClicks', productClicked);
      }
    })
  }
}